/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable react/prop-types, max-len */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddFeaturePermissions.scss';

import ModalAlert from '../../../ModalAlert';
import { updateRoleFeatures } from '../../../../../actions/user';

const fastStyleMargin = {
  marginTop: '7px',
};

class AddFeaturePermissions extends React.Component {
  constructor(props) {
    super(props);
    const i = (_.findIndex(this.props.district.roles, (o) => o.nazwa === 'admin') === 0) ? 0 : 0;
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
      roleIndex: i,
      currentRole: this.unpackRole(this.props.district.roles[i]),
      changedFeatures: [],
    };
  }

  unpackRole = role => {
    const newRole = {
      nazwa: role.nazwa,
      features: [],
    };
    if (this.props.district.features) {

      this.props.district.features.forEach((v) => {
        const hasFeature = _.find(role.features, (o) => o.kod === v.kod);
        let isOn = false;
        hasFeature ? isOn = true : isOn = false;
        newRole.features.push({ kod: v.kod, nazwa: v.nazwa, isOn: isOn, isConfigurable: v.isConfigurable });
      });
      return newRole;
    }
  }

  onConfirm = () => {}
  onChangeRole = (e) => {
    const i = _.findIndex(this.props.district.roles, (o) => o.nazwa === 'admin');
    let selectedIndex = e.target.selectedIndex >= i ? e.target.selectedIndex + 1 : e.target.selectedIndex;
    this.setState({
      isEdited: false,
      roleIndex: selectedIndex,
      currentRole: this.unpackRole(this.props.district.roles[selectedIndex]),
    });
  };

  dismissModal = () => this.setState({ showModal: false });
  dismissConfirm = () => this.setState({ showConfirm: false });

  changeFeatureStatus = (e, v, i) => {
    this.setState({
      currentRole: {
        ...this.state.currentRole,
        features: _.filter(this.state.currentRole.features, (o) => {
          if (o.kod === v.kod) {
            const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
            o.isOn = value;
            return o;
          } else {
            return o;
          }

        }),
      },
    }, () => {
      const hasFeature = _.find(this.state.changedFeatures, (o) => o.kod === v.kod);
      !hasFeature ? this.setState({ changedFeatures: this.state.changedFeatures.concat(v) })
      : this.setState({ changedFeatures: _.filter(this.state.changedFeatures, (o) => o.kod !== v.kod) });
    });
  }

  save = () => {
    this.props.updateRoleFeatures(this.props.district.prefix, this.state.changedFeatures, this.state.currentRole.nazwa)
    .then((resp) => {
      this.setState({ modalTitle: 'Status', modalBody: resp.message, showModal: true, changedFeatures: [] }, () => {
        this.unpackRole(this.props.district.roles[this.state.roleIndex]);
      });
    });
  }

  selectAll = () => {
    this.setState({
      currentRole: {
        ...this.state.currentRole,
        features: _.filter(this.state.currentRole.features, (o) => {
          o.isOn = true;
          return o;
        }),
      },
    }, () => {
      let newChangeState = [];
      this.state.currentRole.features.forEach((v) => {
        const hasFeature = _.filter(this.props.district.roles[this.state.roleIndex].features, (o) => o.kod === v.kod);
        if (hasFeature) newChangeState.push(v);
      });
      this.setState({ changedFeatures: newChangeState });
    });
  }

  deselectAll = () => {
    this.setState({
      currentRole: {
        ...this.state.currentRole,
        features: _.filter(this.state.currentRole.features, (o) => {
          o.isOn = false;
          return o;
        }),
      },
    }, () => {
      let newChangeState = [];
      this.state.currentRole.features.forEach((v) => {
        const hasFeature = _.filter(this.props.district.roles[this.state.roleIndex].features, (o) => o.kod === v.kod);
        if (hasFeature) newChangeState.push(v);
      });
      this.setState({ changedFeatures: newChangeState });
    });
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="form-inline">
            <label htmlFor="selectRole" className="col-xs-3" style={fastStyleMargin}>Nazwa</label>
            <select
              name="selectRole"
              className="form-control"
              value={this.props.district.roles[this.state.roleIndex].nazwa}
              onChange={(e) => this.onChangeRole(e)}
            >
              {this.props.district.roles.map((v, i) => {
                return (v.nazwa !== 'admin') ? <option key={i} value={v.nazwa}>{v.nazwa}</option> : null;
              })}
            </select>
          </div>
        </div>
        <div className="row">

          <h2>Uprawnienia do funkcji systemu</h2>/studio/index.html#/database/ihub/graph
          <p>Włącz lub wyłącz upawnienia dla ról do poszczególnych funkcji systemu.</p>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Funkcja</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.currentRole && this.state.currentRole.features && this.state.currentRole.features.map((v, i) => {
                return (v.isConfigurable) ? (
                  <tr key={i}>
                    <td>{v.nazwa}</td>
                    <td><input name="isOn" type="checkbox" checked={v.isOn} onChange={(e) => this.changeFeatureStatus(e, v, i)} /></td>
                  </tr>
                ) : null;
              })}
            </tbody>
          </table>
          <div className="form-inline">
            {/*<button type="button" className="btn btn-primary" onClick={() => this.selectAll()}>Zaznacz wszystko</button>
            <button type="button" className="btn btn-primary" onClick={() => this.deselectAll()}>Odznacz wszystko</button>*/}
            {this.state.changedFeatures.length > 0 ? <button onClick={() => this.save()} type="button" className="btn btn-primary">Zapisz zmiany</button> : null}
          </div>
          <ModalAlert
            title={this.state.modalTitle}
            bodyText={this.state.modalBody}
            show={this.state.showModal}
            onHide={this.dismissModal}
          />
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  updateRoleFeatures,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddFeaturePermissions));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddFeaturePermissions/AddFeaturePermissions.js